import React from 'react'
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Divider
} from '@mui/material'
import { Sale } from '@starwave/shared/src/types'
import { format } from 'date-fns'

interface InvoiceProps {
    sale: Sale
}

export class InvoiceComponent extends React.Component<InvoiceProps> {
    render() {
        const { sale } = this.props

        return (
            <Box sx={{ p: 4, bgcolor: 'white', color: 'black', maxWidth: '800px', mx: 'auto' }} id="invoice-print-area">
                {/* Header */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
                    <Box>
                        <Typography variant="h4" fontWeight="bold" color="primary">STARWAVE ENERGY</Typography>
                        <Typography variant="body2">Solar Solutions & Power Systems</Typography>
                        <Typography variant="body2">123 Solar Street, Tech City</Typography>
                        <Typography variant="body2">Phone: +92 300 1234567</Typography>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="h5" fontWeight="bold">INVOICE</Typography>
                        <Typography variant="body1">#{sale.invoiceNumber}</Typography>
                        <Typography variant="body2">{sale.date ? format(sale.date.toDate(), 'MMM dd, yyyy') : 'N/A'}</Typography>
                    </Box>
                </Box>

                <Divider sx={{ mb: 4 }} />

                {/* Customer Details */}
                <Box sx={{ mb: 4 }}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>BILL TO:</Typography>
                    <Typography variant="h6" fontWeight="bold">{sale.customerName}</Typography>
                    <Typography variant="body1">{sale.customerContact}</Typography>
                </Box>

                {/* Items Table */}
                <TableContainer sx={{ mb: 4 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Item</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>Qty</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>Price</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sale.items.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Typography variant="body2" fontWeight="bold">{item.productName}</Typography>
                                        <Typography variant="caption" color="text.secondary">{item.category}</Typography>
                                    </TableCell>
                                    <TableCell align="right">{item.quantity}</TableCell>
                                    <TableCell align="right">{item.unitPrice.toLocaleString()}</TableCell>
                                    <TableCell align="right">{item.totalPrice.toLocaleString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Totals */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Box sx={{ width: '300px' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography>Subtotal:</Typography>
                            <Typography>PKR {sale.totalAmount.toLocaleString()}</Typography>
                        </Box>
                        <Divider sx={{ my: 1 }} />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography fontWeight="bold">Total:</Typography>
                            <Typography fontWeight="bold">PKR {sale.totalAmount.toLocaleString()}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography>Paid:</Typography>
                            <Typography>PKR {sale.amountReceived.toLocaleString()}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, color: sale.outstandingAmount > 0 ? 'error.main' : 'inherit' }}>
                            <Typography fontWeight="bold">Balance Due:</Typography>
                            <Typography fontWeight="bold">PKR {sale.outstandingAmount.toLocaleString()}</Typography>
                        </Box>
                    </Box>
                </Box>

                {/* Footer */}
                <Box sx={{ mt: 8, textAlign: 'center', color: 'text.secondary' }}>
                    <Typography variant="body2">Thank you for your business!</Typography>
                    <Typography variant="caption">Startwave Energy - Powering Your Future</Typography>
                </Box>
            </Box>
        )
    }
}

export default InvoiceComponent
